import Icon from "../Icon";
import Button from ".";
import toasty from "@/app/util/toasty";
import { useState } from "react";

function DeleteButton({
	onDelete,
	fileId,
	size = "sm",
	children = "Delete",
	...buttonProps
}) {
	const [isDeleting, setIsDeleting] = useState(false);
	if (!fileId) {
		console.error("DeleteButton: missing fileId");
		return null;
	}
	const handleDelete = async () => {
		setIsDeleting(true);
		try {
			await onDelete(fileId);

			toasty.success("File deleted successfully.");
		} catch (error) {
			toasty.error("Failed to delete file", error);
		} finally {
			setIsDeleting(false);
		}
	};
	return (
		<Button
			variant="danger"
			size={size}
			outline
			onClick={handleDelete}
			loading={isDeleting}
			{...buttonProps}
		>
			{children}
			<Icon name="cross" />
		</Button>
	);
}

export default DeleteButton;
